import React, { PureComponent } from "react";

class RadioGroup extends PureComponent {
  render() {
    const { children, name, onChangeHandler, selected } = this.props;

    return React.Children.map(children, child => {
      return React.cloneElement(child, { name, selected, onChangeHandler });
    });
  }
}

export default RadioGroup;



// WEBPACK FOOTER //
// ./src/components/form/RadioGroup.js